
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the officesSearch module.
 */
const officeSearchConstant = {
	NOT_FOUND_OFFICES: 'No se pudieron adquirir las oficinas',
	OFFICE_LABEL: 'Oficina'
}

export default officeSearchConstant;



// WEBPACK FOOTER //
// ./src/app/core/components/officeSearch/officeSearch.constant.js